import type * as React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { COLORS } from "components/v3/Theme/colors";
import {
  GENOMIC_LIFE_COMPLETE_MEMBER_FEATURES,
  GENOMIC_LIFE_COMPLETE_MEMBER_INTRO
} from "constants/genomicLifeCompleteProgramCopy";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";

const GL_PROGRAM_GENOMIC_LIFE_COMPLETE_DIRECT = "Genomic Life Complete - Direct";

const ActivePlanCard: React.FC = () => {
  const { glProgramId } = useSelector(selectUserPersonalInformation);
  const showBenefitsPackagePill =
    glProgramId !== GL_PROGRAM_GENOMIC_LIFE_COMPLETE_DIRECT;

  return (
    <>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexWrap: "wrap",
          gap: 1.5,
          mb: 2
        }}
      >
        <Typography
          variant="body_strong_black"
          sx={{
            color: COLORS.BLACK,
            fontSize: "1.125rem",
            fontWeight: 700
          }}
        >
          Genomic Life Complete
        </Typography>
        {showBenefitsPackagePill ? (
          <Box
            sx={{
              backgroundColor: COLORS.ACCENT3_LIGHT,
              borderRadius: "999px",
              px: 1.75,
              py: 0.5
            }}
          >
            <Typography
              component="span"
              sx={{
                color: COLORS.ACCENT3_DARKER,
                fontSize: "0.8125rem",
                fontWeight: 600
              }}
            >
              Benefits Package
            </Typography>
          </Box>
        ) : null}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5
        }}
      >
        <Typography
          component="p"
          variant="body2"
          sx={{
            color: COLORS.DARK_GRAY_2,
            lineHeight: 1.65,
            margin: 0
          }}
        >
          {GENOMIC_LIFE_COMPLETE_MEMBER_INTRO}
        </Typography>
        {GENOMIC_LIFE_COMPLETE_MEMBER_FEATURES.map((feature) => (
          <Typography
            key={feature.label}
            component="p"
            variant="body2"
            sx={{
              color: COLORS.DARK_GRAY_2,
              lineHeight: 1.65,
              margin: 0
            }}
          >
            <Box component="span" sx={{ fontWeight: 700 }}>
              {feature.label}
            </Box>{" "}
            {feature.body}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default ActivePlanCard;
